<template>
  <v-card>
    <v-card-title>
      <v-container>
        <v-row>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="12"
            lg="4"
            xl="4"
          >
            <v-text-field
                v-model="currentSelectedCard.name"
                label="Name"
                dense
                hide-details
                outlined
                clearable
            > </v-text-field>
          </v-col>
          <v-col
              cols="10"
              xs="10"
              sm="10"
              md="10"
              lg="4"
              xl="4"
          >
            <v-select
                :items="$store.getters.getKanban.tags"
                v-model="currentSelectedCard.tag"
                item-text="name"
                item-value="uuid"
                label="Tag"
                clearable
                dense
                hide-details
                outlined
            >
            </v-select>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            align="right"
            cols="2"
          >
            <v-btn
                icon
                @click="$parent.currentSelectedCard = null"
            >
              <v-icon
                  color="red"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col
              align="left"
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="3"
              xl="4"
          >
            <v-btn
                class="primary"
                @click="addHistory"
            >
              Neuer Zeitstempel
              <v-icon
                  class="ml-1"
              >
                mdi-archive-clock
              </v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="3"
              xl="4"
          >
            <v-btn
                :disabled="currentSelectedCard.state==0"
                @click="currentSelectedCard.state=0"
            >Plan</v-btn>
            <v-btn
                :disabled="currentSelectedCard.state==1"
                @click="currentSelectedCard.state=1"
            >Offen</v-btn>
            <v-btn
                :disabled="currentSelectedCard.state==2"
                @click="currentSelectedCard.state=2"
            >Warten</v-btn>
            <v-btn
                :disabled="currentSelectedCard.state==3"
                @click="currentSelectedCard.state=3"
            >Erledigt</v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
              align="right"
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="3"
              xl="4"
          >
            <v-btn
                align="right"
                @click="deleteCard"
            >
              Löschen
              <v-icon
                  class="ml-1"
              >
                mdi-delete-empty-outline
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row
        >
          <v-col
            cols="12"
          >
            <v-textarea
                label="History"
                v-model="currentSelectedCard.text"
                no-resize
                :hint="'Erstellt am: ' + currentSelectedCard.created + ' | Zuletzt bearbeitet: ' + currentSelectedCard.lastEdited"
                persistent-hint
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CardEditorBox",
  props: ['currentSelectedCard'],
  watch: {
    currentSelectedCard: {
      handler(oldValue, newValue) {
        if (oldValue != null && newValue != null) {
          if (oldValue.uuid == newValue.uuid) {
            this.update()
          }
        }
      },
      deep: true
    },
  },
  methods: {
    pad(n){
      return n<10 ? '0'+n : n
    },
    getTimeStamp(){
      let date = new Date();
      return date.getFullYear() + "-" + this.pad((date.getMonth() + 1)) + "-" + this.pad(date.getDate()) + " " +  this.pad(date.getHours()) + ":" + this.pad(date.getMinutes());
    },
    update(){
      if(this.currentSelectedCard != null){
        this.currentSelectedCard.lastEdited = this.getTimeStamp()
        this.$store.dispatch('update', {"context": '/set/kanban/cards/' + this.currentSelectedCard.uuid, "payload": this.currentSelectedCard})
      }
    },
    addHistory(){
      let string = this.getTimeStamp()
      string += "\r\n\r\n\r\n"
      this.currentSelectedCard.text = string + this.currentSelectedCard.text
    },
    deleteCard(){
      let cards = this.$store.getters.getKanban.cards
      const index = cards.indexOf(this.currentSelectedCard);
      if (index > -1) { // only splice array when item is found
        cards.splice(index, 1); // 2nd parameter means remove one item only
      }
      this.$store.commit('updateCards', cards)
      this.$store.dispatch('update', {"context": '/delete/kanban/cards/' + this.currentSelectedCard.uuid})
      this.$parent.currentSelectedCard = null
    },
  },
  computed: {
  }
}
</script>

<style scoped>

</style>